const initialState = {
  currentAlbum: null,
  selectedMedia: null,
  fetching: false,
  fetched: false,
  isOpen: false,
  error: null
};

export const displayAlbumReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_DISPLAY_ALBUM": {
      return initialState;
    }
    case "OPEN_DISPLAY_ALBUM": {
      return {
        ...state,
        isOpen: true
      };
    }
    case `RESET_ALBUM`: {
      return initialState;
    }
    case "FETCH_ALBUM_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_ALBUM_FULFILLED": {
      const { data } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        currentAlbum: data.length === 1 ? data[0] : null
      };
    }
    case "FETCH_ALBUM_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_CURRENT_ALBUM": {
      return { ...state, currentAlbum: action.payload };
    }
    case "SET_SELECTED_MEDIA": {
      return { ...state, selectedMedia: action.payload };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/display-album.js